export default __webpack_public_path__ + "static/media/broken-screen-3.ab111e9a.png";